<template>
    <div class="page">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="weui-icon-waiting weui-icon_msg"></i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">确定取消该跑腿单？</h2>
                <div class="weui-cells weui-cells_radio" style="text-align: -webkit-auto;">
                    <label class="weui-cell weui-check__label" for="x11">
                        <div class="weui-cell__bd">
                            <p>个人原因</p>
                        </div>
                        <div class="weui-cell__ft">
                            <input type="radio" class="weui-check" name="radio1" id="x11" checked="checked" @click="choose('个人原因')" />
                            <span class="weui-icon-checked"></span>
                        </div>
                    </label>
                    <label class="weui-cell weui-check__label" for="x12">
                        <div class="weui-cell__bd">
                            <p>用户原因</p>
                        </div>
                        <div class="weui-cell__ft">
                            <input type="radio" name="radio1" class="weui-check" id="x12" @click="choose('用户原因')" />
                            <span class="weui-icon-checked"></span>
                        </div>
                    </label>
                </div>
                <div class="weui-cells weui-cells_form" style="margin-top: -1px;">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" v-model="reason" placeholder="具体原因描述" rows="2"></textarea>
                            <div class="weui-textarea-counter">
                                <span>{{reason.length}}</span>/50</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="weui-msg__opr-area">
                <p class="weui-btn-area">
                    <a href="javascript:;" class="weui-btn weui-btn_primary" @click="cancel">确定取消</a>
                    <a href="javascript:history.back();" class="weui-btn weui-btn_default">返回列表</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      orderNo: "",
      paotuiType: "",
      token: "",
      reasonType: '个人原因',
      reason: ""
    };
  },
  created() {
    this.orderNo = this.$route.params.orderNo;
    this.paotuiType = this.$route.params.paotuiType;
    let encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
  },
  methods: {
    choose(type) {
      this.reasonType = type;
    },
    cancel() {
      if (!this.reason || this.reason.length < 5) {
        weui.alert("取消原因不能少于5个字");
        return;
      } else {
        axios
          .put(
            "/api/paotuiOrder/cancalByPaotui/" +
              this.orderNo +
              "/" +
              this.paotuiType, {reasonType: this.reasonType, reason: this.reason}
          )
          .then(res => {
            if (res.data.success) {
              weui.toast("取消成功", 1500);
              history.back();
            } else {
              weui.alert(res.data.message);
            }
          })
          .catch(err => {
            weui.alert("取消失败");
          });
      }
    }
  }
};
</script>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/operations/CancelPaotuiAccept.vue